export const estimateString = (low, high) => {
  if (low && high) return `${low} - ${high}`;
  if (low) return low;
  if (high) return high;
};

export const formatFloatWithCommasAndDecimals = (
  value,
  precision,
  isDecimalsForced,
  prefix,
  suffix,
  isOnlyFloatsHaveDecimals
) => {
  if (typeof value !== 'number' && typeof value !== 'string') {
    return '';
  }
  let minimumFractionDigits = 0;
  if (isOnlyFloatsHaveDecimals) {
    minimumFractionDigits = Number.isInteger(value) ? 0 : precision;
  } else if (isDecimalsForced) {
    minimumFractionDigits = precision;
  }
  const numberValue = typeof value === 'string' ? value.replace(/[^0-9.-]+/g, '') : value;

  const formattedNumber = (+numberValue).toLocaleString('en', {
    minimumFractionDigits,
    maximumFractionDigits: precision // if precision is undefined, toLocaleString returns up to 3 decimal places
  });
  return `${prefix || ''}${formattedNumber}${suffix || ''}`;
};

export const formatMetricPrefix = (value, prefix, suffix) => {
  const number = Math.abs(Number(value));
  let formattedNumber = `${number}`;
  if (number >= 1.0e9) {
    formattedNumber = `${Math.round((number / 1.0e9) * 10) / 10}B`;
  } else if (number >= 1.0e6) {
    formattedNumber = `${Math.round((number / 1.0e6) * 10) / 10}M`;
  } else if (number >= 1.0e3) {
    formattedNumber = `${Math.round((number / 1.0e3) * 10) / 10}K`;
  }
  return `${prefix || ''}${formattedNumber}${suffix || ''}`;
};
